/**
 * Times are stored in UTC (ISO strings). The page shows them in the viewer's own time zone, and the admin statistics count
 * days by the viewer's local date (JF 2026-10-14: the admin page showed UTC, 8 hours behind Hong Kong / China).
 */
const pad = (x: number) => String(x).padStart(2, "0");
/** "2026-10-14 10:10" in this computer's time zone ("—" for nothing) */
export function localTime(iso: string | null | undefined, empty = "—"): string {
  if (!iso) return empty;
  const d = new Date(iso);
  if (isNaN(+d)) return String(iso).slice(0, 16).replace("T", " ");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
/** minutes east of UTC on this computer (Hong Kong / China: 480) */
export const tzOffset = () => -new Date().getTimezoneOffset();
